import { Link } from "react-router-dom";
import { Logo } from "./Logo";

export const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <Link to="/" aria-label="Cactus — Home">
      <Logo size={32} />
    </Link>
    <span className="footer-copy" data-testid="footer-copyright">© Cactus Branding 2026</span>
  </footer>
);
